// extracted by mini-css-extract-plugin
export default {"wrapper":"GR-z","firstToReview":"HR-z","productCards":"IR-z","productCard":"JR-z","stars":"KR-z","hidden":"LR-z"};